export default {"src":"/polygon/_next/static/media/wallet.d07c78e0.svg","height":161,"width":160};